import { render, staticRenderFns } from "./DvMaskaField.vue?vue&type=template&id=0124ce85&lang=pug"
import script from "./DvMaskaField.vue?vue&type=script&lang=js"
export * from "./DvMaskaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports